'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var TransitionPortal = (function (_React$Component) {
    _inherits(TransitionPortal, _React$Component);

    function TransitionPortal(props) {
        _classCallCheck(this, TransitionPortal);

        _get(Object.getPrototypeOf(TransitionPortal.prototype), 'constructor', this).call(this, props);
        this.portalElement = null;
    }

    _createClass(TransitionPortal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var p = document.createElement('div');
            document.body.appendChild(p);
            this.portalElement = p;
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            _reactDom2['default'].render(_react2['default'].createElement(
                _reactAddonsCssTransitionGroup2['default'],
                this.props,
                this.props.children
            ), this.portalElement);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeChild(this.portalElement);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return TransitionPortal;
})(_react2['default'].Component);

var Modal = (function (_React$Component2) {
    _inherits(Modal, _React$Component2);

    function Modal() {
        _classCallCheck(this, Modal);

        _get(Object.getPrototypeOf(Modal.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Modal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isOpen) {
                if (document && document.body) {
                    document.body.style.overflow = 'hidden';
                }
            } else {
                if (document && document.body) {
                    setTimeout(function () {
                        document.body.style.overflow = 'visible';
                    }, 400);
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (document && document.body) {
                setTimeout(function () {
                    document.body.style.overflow = 'visible';
                }, 400);
            }
        }
    }, {
        key: 'handleClose',
        value: function handleClose() {
            this.props.onCancel();
        }
    }, {
        key: 'onContentClick',
        value: function onContentClick(event) {
            // Parent div 'Modal' closes the modal on click event.
            // Prevent click event propagating to the Parent div 'Modal'.
            if (event.stopPropagation) {
                event.stopPropagation();
            } else {
                event.returnValue = false; //For IE
            }
        }
    }, {
        key: 'renderDialog',
        value: function renderDialog() {
            var _this = this;

            if (!this.props.isOpen) return false;
            var close = this.props.showCloseButton ? _react2['default'].createElement('button', { type: 'button', onClick: this.handleClose.bind(this), className: 'Modal__close' }) : null;
            var back = this.props.back ? _react2['default'].createElement(
                'div',
                { className: 'Modal__back' },
                this.props.back
            ) : null;
            return _react2['default'].createElement(
                'div',
                { className: 'Modal-' + this.props.type, id: 'modalDialog' },
                _react2['default'].createElement(
                    'div',
                    {
                        ref: function (ref) {
                            _this.modalElement = ref;
                        },
                        style: this.props.width && !isNaN(this.props.width) ? { width: this.props.width + 20 } : null,
                        tabIndex: '0',
                        className: (0, _classnames2['default'])('Modal-content-' + this.props.type, this.props.width && isNaN(this.props.width) ? 'Modal-content--' + this.props.type + '--' + this.props.width : null),
                        onClick: this.onContentClick.bind(this)
                    },
                    close,
                    back,
                    this.props.children
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var className = (0, _classnames2['default'])('Modal', {
                'is-open': this.props.isOpen,
                'is-opaque': this.props.opaque
            }, this.props.className);
            var props = (0, _blacklist2['default'])(this.props, 'backdropClosesModal', 'className', 'isOpen', 'onCancel', 'type');
            return _react2['default'].createElement(
                TransitionPortal,
                _extends({}, props, {
                    'data-modal': 'true',
                    className: className,
                    onClick: this.props.backdropClosesModal ? this.handleClose.bind(this) : function () {},
                    transitionName: 'Modal-' + this.props.type,
                    component: 'div',
                    transitionEnterTimeout: 350,
                    transitionLeaveTimeout: 350
                }),
                this.renderDialog()
            );
        }
    }]);

    return Modal;
})(_react2['default'].Component);

Modal.propTypes = {
    back: _propTypes2['default'].node,
    backdropClosesModal: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    onCancel: _propTypes2['default'].func,
    opaque: _propTypes2['default'].bool,
    showCloseButton: _propTypes2['default'].bool,
    type: _propTypes2['default'].oneOf(['dialog', 'default']),
    width: _propTypes2['default'].oneOfType([_propTypes2['default'].oneOf(['small', 'medium', 'large']), _propTypes2['default'].number])
};

Modal.defaultProps = {
    width: 'medium',
    showCloseButton: true,
    backdropClosesModal: true,
    type: 'default',
    opaque: false
};

module.exports = Modal;
// expose the children to the top level export
module.exports.Body = require('./ModalBody');
module.exports.Footer = require('./ModalFooter');
module.exports.Header = require('./ModalHeader');


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Modal.js
// module id = 970
// module chunks = 0 1